module.exports = __webpack_public_path__ + "img/services-icon-5.989b002e.png";